import React from "react";

export default class Error extends React.Component {
    render() {
        return (
            <h2>Page Not Found</h2>
        )
    }
}